/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/User/Active/Label
 * @desc Active filter component for user
 */

import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import type React from 'react';
import type { FilterPostNewIndexUserActiveLabelProps } from './types';

export const FilterPostNewIndexUserActiveLabel: React.FC<
  FilterPostNewIndexUserActiveLabelProps
> = ({ user, type, onRemoveClick }) => (
  <RemoveLabel
    icon={type === 'assignee' ? 'user plus' : 'user circle'}
    name={user.name}
    onRemoveClick={onRemoveClick}
  />
);
